export const MOBILE_WIDTH = 800;
//export const baseURL ="https://elhb2kn3e7.execute-api.us-east-1.amazonaws.com/Development/api/" ;
//export const baseURL = process.env.REACT_APP_API_BASEURL;
//console.log(baseURL)
  

  